import React, { Component } from "react";
import '../../css/Services.css';

var vserv = JSON.parse(localStorage.getItem('service'));

export default class ServiceScreen extends Component {

  constructor(props) {
      super(props);
      this.state = {
        nom:'',
        texte_html:'',
        accordeonOpen: [],
      }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  getHTML = (text) => {
    return {__html: text};
  }

  _Drlist = (data) => {
    var str = "";
    for (const [key, value] of Object.entries(data)){
      if (value.nom_affichage) {
        str += value.nom_affichage+", ";
      }
    }
    return str.substring(0, str.length-2);
  }

  handleClick(index:number) {
    let stateOpen = this.state.accordeonOpen;
    if (stateOpen[index] === 'oui') {
        stateOpen[index] = 'non';
    } else {
        stateOpen[index] = 'oui';
    }
    this.setState({
        index: this.state.index + 1,
        accordeonOpen: stateOpen,
      });
  }

  renderAccordeons = (data) => {
    return data.map((accordeon, index) => {
      const { title, content } = accordeon;
      const stateOpen = this.state.accordeonOpen;
      let contentClassName = 'accordeon-content';
      let triggerClassName = 'subtitle accordeon-title accordeon-trigger';
      if (stateOpen[index] !== 'oui') {
          contentClassName += ' is-hidden';
          triggerClassName += ' is-closed';
      }
      return (
        
        <div className="accordeon" key={index}>
          <h2 className={triggerClassName} onClick={this.handleClick.bind(this, index)} dangerouslySetInnerHTML={this.getHTML(title)} />
          <div className={contentClassName} dangerouslySetInnerHTML={this.getHTML(content)} />
        </div>
      )
    })
  }

 render() {

    const service = this.props.location.datas
      ? this.props.location.datas
      : vserv;


    if (this.props.location.datas) {
      localStorage.setItem('service', JSON.stringify(this.props.location.datas));
    }

    if (!service) {
      return (
        <div className="App">
          <p></p>
        </div>
      );
    }

    return (
      <section className="section">
        <div className="container">
          <h1 className="title">{service.nom}</h1>
          <br />
          
          <div className="divcontent">
            <div className="introcontent" dangerouslySetInnerHTML={this.getHTML(service.texte_intro)} />
            {this.renderAccordeons(service.accordeons)}
          </div>
        </div>
      </section>
    )
  }
}
